import React from 'react';
import { useHistory, matchPath } from 'react-router-dom';

import './ContentTickertape.scss';
import useCheckProduct from '../../hooks/useCheckProduct';
import useCheckDatetime from '../../hooks/useCheckDatetime';
import useCheckContentVisibility from '../../hooks/useCheckContentVisibility';

export default function ContentTickertape({ data, preview }: { data: Record<string, any>, preview: boolean }) {
  const tickertapes = preview ? data.tickertapes[0] : data.tickertapes;
  const history = useHistory();
  const checkProduct = useCheckProduct(tickertapes);
  const checkDatetime = useCheckDatetime(tickertapes);
  const checkVisibility = useCheckContentVisibility(tickertapes);
  const matchPage = matchPath(history.location.pathname, {
    path: ['/lotto', '/sports-betting/:type', '/racing/:type'],
    exact: true,
    strict: true
  });

  if ((matchPage || preview && (checkProduct && checkDatetime && checkVisibility)) && tickertapes) {
    return (
      <div className="tickertape">
        <div className="tickertape__title">{ tickertapes.title }</div>
        <div className="tickertape__body">
          <span className="tickertape__message">{ tickertapes.body }</span>
        </div>
      </div>
    );
  }

  return null;
}
